import React from 'react'
import spendingAlertError from "../../../../../assets/images/spending-alert-error.png"
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useDispatch, useSelector } from 'react-redux'
import { appTheme } from '../../../../../helpers/utils/Utils';
import logFirebaseEvents from '../../../../LogFirebaseEvents';


const ErrorAllocateModal = ({ isSubErrMsg,onBack }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    const handleTryAgain = () => {
        dispatch({ type: 'ERROR_ALLOCATE_MODAL', payload: { errorAllocateModal: false } });
        dispatch({ type: "RESET_SAVING_GOALS" })
        dispatch({ type: "RESET_ALLOCATE_FUND" })
        navigate('/Toolkit/SavingGoals/ManageSavingGoal');
        onBack("SavingGoalFields")
    }

    const handleBackToClimb = () => {
        logFirebaseEvents("Allocate_Fund", "BackTo_Climb_Clicked", "BackTo_Climb_Clicked","", "")
        dispatch({ type: "RESET_ALLOCATE_FUND" })
        dispatch({ type: "RESET_SAVING_GOALS" })
        dispatch({type:"ERROR_ALLOCATE_MODAL", payload: { errorAllocateModal: false } })
        navigate('/Toolkit/ToolkitMenu');
    }

    return (
        <div className=' flex flex-col w-full'>
 
                {/* <p className='font-hanken-grotesk font-[400] sm:font-[500] 
                leading-[24px] lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[22px] md:leading-[28px]
                 text-secondary-3'>{t("Please_Try_Again")}</p> */}
                             <p className='font-hanken-grotesk lg:text-[18px] md:text-[18px] sm:text-[14px] text-[16px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] 
             md:leading-[28px] text-[var(--heading-in-modal-is-clr)] '>{t("Please_Try_Again")}</p>
 

            <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10 mx-auto' />
            {/* <div className=' flex flex-col justify-center items-center w-full'>
                <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={handleBackToSavingGoals} onKeyDown={(e) => { if (e.key === "Enter") handleBackToSavingGoals() }}>{t("saving_goals")}</button>
            </div> */}

<div className=' flex flex-col justify-center items-center gap-8 w-full'>
                    

                    <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
 sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={ handleTryAgain} onKeyDown={(e) => { if (e.key === "Enter") handleTryAgain() }}>{t("try_again")}</button>
                
                        <button class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
 sm:text-[15px] text-[16px] font-[400] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px]  text-white cursor-pointer border-2 px-2 py-4 border-[#4B70B9] w-full" onClick={ handleBackToClimb} onKeyDown={(e) => { if (e.key === "Enter") handleBackToClimb() }}>{t("back_to_climb")}</button>
                    
                </div>

        </div>
    )
}

export default withOidcSecure(ErrorAllocateModal)